import { useSearchParams } from 'react-router';

import includes from 'lodash/fp/includes';

import { productsCategories } from 'constants/products';
import {
  STYLING_GEL_CONSULTATION_QUESTION_SET_KEY,
  SUPPLEMENTS_CONSULTATION_QUESTION_SET_KEY,
} from '../constants';

import { useConsultationCategory } from './useConsultationCategory';

const haircareConsultationSubsetCategory = [
  STYLING_GEL_CONSULTATION_QUESTION_SET_KEY,
  SUPPLEMENTS_CONSULTATION_QUESTION_SET_KEY,
];

export const useConsultationSubsetCategory = () => {
  const consultationCategory = useConsultationCategory();
  const [params] = useSearchParams();
  if (
    consultationCategory === productsCategories.HAIRCARE &&
    params.has('questionSet') &&
    includes(params.get('questionSet'), haircareConsultationSubsetCategory)
  ) {
    return params.get('questionSet');
  }
  // Future other cases might be skincare subsets
  return null;
};
